import React from 'react';
export const useUtils = ({ onChange, nullable, disabled, onFocus, onBlur, children, selected, name, id }) => {
    const [isOpenSelect, setIsOpenSelect] = React.useState(false);
    const [selectedOption, setSelectedOption] = React.useState();
    const selectRef = React.useRef(null);
    const optionRefs = React.useRef([]);
    const handleFocusCurrentOption = React.useCallback(() => {
        setTimeout(() => {
            var _a;
            let currentIndex = optionRefs.current.findIndex((ref) => (ref === null || ref === void 0 ? void 0 : ref.dataset.isActive) == 'true');
            if (currentIndex === -1)
                currentIndex = 0;
            (_a = optionRefs.current[currentIndex]) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
    }, [optionRefs]);
    const handleChangeSelect = React.useCallback(({ selectValue, selectName, selectId, disabled }) => {
        if (!disabled) {
            if (onChange) {
                onChange({
                    selectValue: nullable && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === selectValue ? undefined : selectValue,
                    selectName: nullable && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === selectValue ? undefined : name,
                    selectId: nullable && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === selectValue ? undefined : id,
                    name: name,
                });
            }
            setSelectedOption((prev) => {
                return {
                    value: nullable && (prev === null || prev === void 0 ? void 0 : prev.value) === selectValue ? undefined : selectValue,
                    name: nullable && (prev === null || prev === void 0 ? void 0 : prev.value) === selectValue ? undefined : selectName,
                    id: nullable && (prev === null || prev === void 0 ? void 0 : prev.value) === selectValue ? undefined : selectId,
                };
            });
        }
    }, [name, nullable, selectedOption, id]);
    const handleFocusSelect = React.useCallback((e) => !disabled && onFocus && onFocus(e), [disabled, onFocus]);
    const handleOpenSelect = React.useCallback((e) => {
        if (!disabled) {
            setIsOpenSelect((prev) => {
                if (prev && onBlur)
                    onBlur(e);
                return !prev;
            });
            handleFocusCurrentOption();
        }
    }, [disabled, optionRefs, selectRef]);
    React.useEffect(() => {
        const selectedChild = React.Children.toArray(children).find((child) => {
            return React.isValidElement(child) && (child.props.value === selected || child.props.selected === true);
        });
        if (React.isValidElement(selectedChild)) {
            setSelectedOption({
                value: selectedChild.props.value,
                name: selectedChild.props.children || selectedChild.props.label,
                id: selectedChild.props.id,
            });
        }
        else {
            setSelectedOption({
                value: undefined,
                name: undefined,
                id: undefined,
            });
        }
    }, [children, selected]);
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            var _a;
            if (isOpenSelect && !((_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                if (onBlur)
                    onBlur(event);
                setIsOpenSelect(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpenSelect, selectRef, onBlur]);
    React.useEffect(() => {
        optionRefs.current = optionRefs.current.slice(0, React.Children.toArray(children).length);
    }, [optionRefs]);
    return {
        handleChangeSelect,
        handleFocusCurrentOption,
        handleFocusSelect,
        handleOpenSelect,
        isOpenSelect,
        setIsOpenSelect,
        optionRefs,
        selectRef,
        selectedOption,
    };
};
//# sourceMappingURL=utils.js.map